import React from 'react'
import Header from '../../../../Components/Header'
import Createwarehouse from './Createwarehouse'
import { Helmet } from 'react-helmet'

function CreateBinMaster() {
  return (



    <div className='d-flex flex-column' style={{ minHeight: '100vh' }}>
      <Helmet>
				<title>Bin - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column " style={{ flexGrow: '1' }}>
        <Createwarehouse />
      </div>
    </div>

  )
}

export default CreateBinMaster
